module.exports = __webpack_public_path__ + "img/img_shenqingbiao.a93cab60.jpg";